export default async function bitacora({ next, router, store }) {
  await store.dispatch("Autentication:BitacoraTotalCorreo", {usuarioId: JSON.parse(localStorage.getItem('pObjDatosSession')).usuarioEmpresaId})
    if(store.state.Login.BitacoraTotalCorreo === 0){
      return next("/ActualizaCorreo");
    } else {
      return next();
    }
}